import { useEffect, useState } from 'react';

/** ძებნის ველისთვის — ყოველ ასოზე მოთხოვნას არ ვაგზავნით */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
